<template>
  <div class="documents-link width-responsiveness">
    <modal
      ref="deleteLinkationModal"
      template="loading"
      title="Aguarde"
      ref-name="deleteDocumentModal"
    >
      <p>Excluindo associação.</p>
    </modal>

    <modal
      ref="savingLinkationModal"
      template="loading"
      title="Aguarde"
      ref-name="savingDocumentModal"
    >
      <p>Salvando associação.</p>
    </modal>

    <modal
      ref="questionDeleteLinking"
      template="question"
      title="Excluir associação"
      ref-name="questionDeleteLinking"
      first-button-text="Cancelar"
      second-button-text="Sim"
      :close-button-enabled="true"
      :icon-enabled="false"
      @first-cta="closeQuestionLinkingModal()"
      @second-cta="deleteLinkation()"
    >
      <p>Tem certeza que deseja excluir a associação entre documento e exame?</p>
    </modal>

    <subheader title="Associar Documentos à Exames" />

    <card-form :collapsed="true">
      <div
        slot="expanded"
        class="form-container"
      >
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout md-flex="40">
            <label>Documento</label>
            <md-input-container
              v-if="!loadingDocumentCbo"
              name="documento"
            >
              <advanced-select
                id="cboDocument"
                v-model="documentSelected"
                v-validate="'required'"
                label="fileName"
                :options="documentsOptions"
                name="documento"
                placeholder="Selecione um documento"
                data-vv-validate-on="none"
                z
              />
              <span class="md-error">Obrigatório</span>
            </md-input-container>
            <spinner v-else />
          </md-layout>

          <md-layout md-flex="40">
            <label>Exame</label>
            <md-input-container class="search">
              <search
                ref="search"
                :only-get-exam-id="true"
                :fetch="searchExam"
                :min-chars="2"
                :placeholder="searchInitialPlaceholder"
                class="search__input-container"
                @exam-id-selected="getExamSelected"
              />
            </md-input-container>
          </md-layout>

          <md-layout
            md-flex="10"
            class="button-container"
          >
            <md-button
              class="btn btn-primary"
              :disabled="isFieldsEmpty"
              @click="createLinkation()"
            >
              SALVAR
            </md-button>
          </md-layout>
        </md-layout>
      </div>
    </card-form>

    <div class="documents-new__patient">
      <h2 class="documents-new__patient__title title-main">
        Associações Cadastradas
      </h2>
    </div>

    <div
      v-if="!loadingLinkations && linkations.length === 0"
      class="empty-cart"
    >
      <img
        src="/static/images/icon-lists.svg"
        alt="Não há documentos cadastrados ainda"
      >
      <h2>Não há associações salvas ainda.</h2>
    </div>

    <documents-list
      v-else
      :get-all-linkations="getAllLinkations"
      :loading="loadingLinkations"
      :linkations="linkations"
      @delete-linkation="openQuestionLinkingModal"
    />
  </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader'
import CardForm from '@/components/common/CardForm'
import AdvancedSelect from '@/components/common/AdvancedSelect'
import Search from '@/components/common/Search'
import DocumentsList from './DocumentsLinkList'
import { mapActions } from 'vuex'
import documentManagementService from '@/api/documentManagement'
import notify from '@/api/notification'
import Spinner from '../../../common/Spinner'

let INITIAL_PLACEHOLDER_SEARCH =
  'Digite o nome ou código do exame que deseja adicionar…'

export default {
  components: {
    'card-form': CardForm,
    subheader: SubHeader,
    'advanced-select': AdvancedSelect,
    search: Search,
    'documents-list': DocumentsList,
    spinner: Spinner
  },
  data: () => {
    return {
      documentsOptions: [],
      documentSelected: null,
      loadingDocumentCbo: false,
      loadingLinkations: false,
      linkations: [],
      examIdSelected: 0,
      linkingIdToDelete: 0,
      searchInitialPlaceholder: INITIAL_PLACEHOLDER_SEARCH
    }
  },
  methods: {
    ...mapActions(['searchExam']),
    getAllDocuments () {
      this.loadingDocumentCbo = true
      documentManagementService
        .getAllDocuments()
        .then(response => {
          this.documentsOptions = response.data
          this.loadingDocumentCbo = false
        })
        .catch(() => {
          notify({
            title: 'AVISO:',
            message: 'Não foi possível carregar os documentos cadastrados.'
          })
          this.loadingDocumentCbo = false
        })
    },
    getAllLinkations () {
      this.loadingLinkations = true
      this.linkations = []
      documentManagementService
        .getAllExamsAndDocumentsLinked()
        .then(response => {
          this.linkations = response.data
          this.loadingLinkations = false
        })
        .catch(() => {
          notify({
            title: 'AVISO:',
            message: 'Não foi possível carregar as associações cadastradas.'
          })
          this.loadingLinkations = false
        })
    },
    createLinkation () {
      this.$refs.savingLinkationModal.open()
      documentManagementService
        .createLinkOverDocumentAndExam({
          examId: this.examIdSelected,
          fileId: this.documentSelected.id
        })
        .then(response => {
          this.$refs.savingLinkationModal.close()
          notify({
            title: 'AVISO:',
            message: 'Associação criada com sucesso.'
          })
          this.reloadDataTable()
          this.clearFields()
        })
        .catch(() => {
          this.$refs.savingLinkationModal.close()
          notify({
            title: 'AVISO:',
            message: 'Não foi possível criar associação.'
          })
        })
    },
    deleteLinkation () {
      this.closeQuestionLinkingModal()
      this.$refs.deleteLinkationModal.open()
      documentManagementService
        .deleteLinkOverDocumentAndExam(this.linkingIdToDelete)
        .then(response => {
          this.$refs.deleteLinkationModal.close()
          notify({
            title: 'AVISO:',
            message: 'Associação excluída com sucesso.'
          })
          this.reloadDataTable()
          this.clearFields()
        })
        .catch(() => {
          this.$refs.deleteLinkationModal.close()
          notify({
            title: 'AVISO:',
            message: 'Não foi possível excluir a associação.'
          })
        })
    },
    reloadDataTable () {
      this.getAllLinkations()
    },
    clearFields () {
      this.documentSelected = null
      this.linkingIdToDelete = 0
      this.$refs.search.placeholderCustom = INITIAL_PLACEHOLDER_SEARCH
    },
    getExamSelected (examId) {
      this.examIdSelected = examId
    },
    openQuestionLinkingModal (linkId) {
      this.linkingIdToDelete = linkId
      this.$refs.questionDeleteLinking.open()
    },
    closeQuestionLinkingModal () {
      this.$refs.questionDeleteLinking.close()
    }
  },
  computed: {
    isFieldsEmpty: function () {
      return this.documentSelected === null || this.examIdSelected === 0
    }
  },
  mounted () {
    this.getAllDocuments()
    this.getAllLinkations()
  }
}
</script>

<style lang="scss">
@import "../../../../../static/stylesheets/mixins";
@import "../../../../../static/stylesheets/variables";
@import "../../../../../static/stylesheets/components/orders/empty-cart";

.documents-link {
  margin-top: $headerAndSubHeaderHeight;

  .title-main {
    font-size: 12px;
    letter-spacing: 0.1px;
    text-align: start;
    color: #7f1a54;
    font-weight: 600;
    text-transform: uppercase;
    margin: 48px 0 30px;
  }

  .md-icon svg {
    margin-top: 20px;
  }

  .button-container {
    display: flex;
    align-content: center;
    margin: auto;
  }

  .search-container {
    width: 100%;
  }

  .multiselect__placeholder {
    font-size: 15px;
    color: #333;
  }

  .empty-cart {
    margin: 0;
    justify-content: flex-start;
  }

  .form-container {
    label {
      color: rgba(0, 0, 0, 0.54);
      font-size: 16px;
      line-height: 20px;
    }
  }

  .advanced-select__container .multiselect__content-wrapper {
    max-width: 40%;
  }

  .multiselect__option {
    span {
      max-width: 40%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
